import { getBounds } from 'geolib';

export type GroupedLocationsType = {
    city: { id: string; name: string; slug: string; state: { id: string; name: string; slug: string } };
    locations: any[];
}[];

export const normalizePhone = (phone: string) => {
    if (!phone) return null;

    const formatPhone = (phone: string) => {
        const parts = phone.replace(/\s/g, '').split('-');
        if (parts.length <= 1) {
            return phone;
        }

        return `${parts[0]} ${parts[1].substring(0, parts[1].length - 3)} ${parts[1].substring(parts[1].length - 3)}`;
    };

    if (Array.isArray(phone)) {
        return phone.map((p: string) => formatPhone(p));
    }

    const p = phone
        .replace(/;/g, ',')
        .replace(/\r\n|\r|\n/g, ',')
        .replace(/\s/g, '');
    return p.split(',').map((p) => formatPhone(p));
};

export const groupLocationsByCity = (locations: any): GroupedLocationsType =>
    Object.values(
        locations.reduce((acc, l) => {
            const key = l.city?.slug || 'undefined';
            if (!acc[key]) {
                acc[key] = {
                    city: { ...l.city },
                    locations: [],
                };
            }
            acc[key].locations.push({
                id: l.id,
                code: l.code,
                address: l.address,
                geo_point: l.geo_point,
                phone: normalizePhone(l.phone),
                schedule: l.schedule,
                type: l.type,
                name: l.name,
                slug: l.slug,
                city: l.city,
            });

            return acc;
        }, {}),
    )
        .sort((a: any, b: any) => {
            if (a.locations.length === b.locations.length) return a.city.name.localeCompare(b.city.name);
            return b.locations.length - a.locations.length;
        })
        .map((item: any) => ({
            ...item,
            locations: item.locations.sort((a: any, b: any) => {
                if (a.type !== b.type) {
                    return a.type === 'Laborator' ? -1 : 1;
                }
                return a.name.localeCompare(b.name);
            }),
        }));

export const citiesMapFromLocations = (locations: any[]) =>
    locations?.reduce((current: { [key: string]: any[] }, item) => {
        const toAdd = item.city;
        const key = toAdd.state.slug;
        if (!current[key]) {
            current[key] = [toAdd];
            return current;
        }

        if (current[key].find((i) => i.slug === toAdd?.slug)) {
            return current;
        }

        current[key].push(toAdd);
        current[key] = current[key].sort((a, b) => a.name?.localeCompare(b.name));
        return current;
    }, {});

export const normalizeLocationsByCity = (locationsByCity: any[]) =>
    locationsByCity.reduce((current, item) => [...current, ...item.locations], []);

export const boundsForPoints = (points: [number, number][], offset = 0.02): [number, number, number, number] => {
    const bounds = getBounds(points);
    return [bounds.minLng - offset, bounds.minLat - offset, bounds.maxLng + offset, bounds.maxLat + offset];
};
